import { useEffect, useState } from "react";
import {
    DKLabel,
    DKButton,
    DKInput,
    INPUT_VIEW_DIRECTION,
    DKIcon,
    DKExpandableWrapper,
    DKLine,
    removeLoader,
    DKSpinner,
    showLoader,
    showToast,
    TOAST_TYPE,
    DKIcons
} from "deskera-ui-library";
import MaskInputUtil from "../../../../SharedComponents/MaskInput/MaskInputUtil";
import { APPENDIX_8B, APPENDIX_8B_FORM_SUB_SECTION_FIELDS, APPENDIX_8B_SECTION_FIELDS, EXERCISES, TYPE_OF_PLANS } from "./SGReportsConstant";
import Utility, { deepClone } from "../../../../utility/Utility";
import EmployeeListService from "../../../../services/EmployeeListService";
import MaskInput from "../../../../SharedComponents/MaskInput/MaskInput";
import { CONSTANTS, ERF, FORMAT, INPUT_TYPE } from "../../../../constants/Constant";
import { useDispatch, useSelector } from "react-redux";
import { fetchEmployeeList, selectEmployeeList } from "../../../../Redux/Slices/SGFormsSlice";
import { TENANT, TenantService } from "../../../../managers/TenantManagerService";
import moment from "moment";
import { removeFirstDecimalFromInput, scrollToError } from "../../../../managers/common/CommonUtil";
import IRASService from "../../../../services/IRASService";

const Appendix8BForm = (props) => {

    /**Hooks */
    const [appendix8BFromConfig, setAppendix8BFromConfig] = useState(APPENDIX_8B);
    const [mask, setMask] = useState(MaskInputUtil.MASK_STATE);
    const maskUnmaskObservable =
        MaskInputUtil.subscripeToMaskUnmaskObservable(setMask);
    const [formValues, setFromValues] = useState({
        "SectionA": {"set1": {},"set2":{},"set3":{}},
        "SectionB": {"set1": {},"set2":{},"set3":{}},
        "SectionC": {"set1": {},"set2":{},"set3":{}},
        "SectionD": {"set1": {},"set2":{},"set3":{}},
    });
    const [formDetails, setFromDetails] = useState(props?.data?.formDetails);
    const [isLoading, setIsLoading] = useState(true);
    const [autorizedList, setAuthorizedData] = useState([]);
    const [expandedState, setFormExpandedState] = useState({
        "SectionA": {"isExpanded" : true, "set1": {"isExpanded" : false,},"set2":{"isExpanded" : false,},"set3":{"isExpanded" : false,}},
        "SectionB": {"isExpanded" : false,"set1": {"isExpanded" : false,},"set2":{"isExpanded" : false,},"set3":{"isExpanded" : false,}},
        "SectionC": {"isExpanded" : false,"set1": {"isExpanded" : false,},"set2":{"isExpanded" : false,},"set3":{"isExpanded" : false,}},
        "SectionD": {"isExpanded" : false,"set1": {"isExpanded" : false,},"set2":{"isExpanded" : false,},"set3":{"isExpanded" : false,}},
    })

    /**Selectors */
    const employeeList = useSelector(selectEmployeeList);

    /**Dipatcher */
    const dispatch = useDispatch();

    useEffect(() => {
        loadEmployeeList();
    },[])

    useEffect(() => {
        if(employeeList?.users?.length > 0) {
            let users = employeeList?.users.filter((user) => {
                return !Utility.isEmpty(user?.compliance?.assignCPFAccount)      
            }).map((user) => {
                return {
                    id: user.userId, name : `${user.firstName} ${user.lastName}`, user_id:user.userId, ...user
                }
            })
            setAuthorizedData(users)
        }        
    },[employeeList])

    useEffect(() => {
        if(autorizedList?.length > 0) {
            updateFormConfig(autorizedList);
            updateFormValues(autorizedList);
        }
    },[autorizedList])

    const loadEmployeeList = async () => {
        try {
            await dispatch(fetchEmployeeList())
        }catch(err) {
            console.error("Error loading employee details: ", err);
        }
    }

    const updateFormValues = (usersData) => {
        const configData = formDetails;
        formValues["employeeFullName"] = getUserFullName(configData["employee"]);
        formValues["taxRefNo"] = configData["taxRefNo"];
        formValues["authorizePerson"] = getAuthorizedPerson(configData, usersData);
        setFormSectionValues(configData);
        setIsLoading(false);
    }

    const getUserFullName = (employee) => {
        if(!Utility.isEmptyObject(employee)) {
            return `${employee.firstName} ${employee.lastName}`
        }
        return CONSTANTS.EMPTY_STRING;
    }

    const setFormSectionValues = (configData) => {
        const sections = configData["sections"];
        if(sections?.length > 0) {
            sections.forEach((s) => {
                const sCode = s?.sectionType;
                const sbCode = APPENDIX_8B_SECTION_FIELDS[s.sectionIndex]?.columnCode;
                for(const k in s) {
                    switch(k) {
                        case "planGrantDate":
                        case "exerciseDate":
                        case "dateOfExpiryOfExercise":
                            formValues[sCode][sbCode][k] = getFormFormattedDate(s[k]);
                            break;
                        case "planGrantedType":
                            formValues[sCode][sbCode][k] = EmployeeListService.getValueObjectFromDropdown(s[k], TYPE_OF_PLANS, "id");
                            break;
                        case "typeOfExercise":
                            formValues[sCode][sbCode][k] = EmployeeListService.getValueObjectFromDropdown(s[k], EXERCISES, "id");
                            break
                        default:
                            formValues[sCode][sbCode][k] = s[k];
                    }                    
                }
            })
        }
    }

    const getFormFormattedDate = (value) => {
        if(!Utility.isEmpty(value)) return moment(value, FORMAT.YYYYMMDD).toDate();
        return value;
    }

    const getAuthorizedPerson = (formDetails, usersData) => {
        const personDetails = formDetails["authorizePerson"];
        let userId = TenantService.get(TENANT.USER_ID);
        if(!Utility.isEmptyObject(personDetails)) {
            const eIndex = autorizedList.findIndex(u => u.userId === personDetails.user_id);
            if(eIndex === -1) {
                let group = {
                    id: personDetails["user_id"],
                    name: `${personDetails.firstName} ${personDetails.lastName}`,
                    ...personDetails
                }; 
                autorizedList.push(group)  
            }
            userId = personDetails["user_id"];
            
        }
        return EmployeeListService.getValueObjectFromDropdown(userId, autorizedList, "id");
    }

    const updateFormConfig = (users) => {
        const formConfig = deepClone(appendix8BFromConfig);
        const sectionFields = deepClone(APPENDIX_8B_SECTION_FIELDS)
        const alteredSectionFields = [
            {columnCode: "set1", fields:APPENDIX_8B_FORM_SUB_SECTION_FIELDS},
            {columnCode: "set2", fields:APPENDIX_8B_FORM_SUB_SECTION_FIELDS},
            {columnCode: "set3", fields:APPENDIX_8B_FORM_SUB_SECTION_FIELDS}
        ];
        EmployeeListService.getAlteredConfigDetails(sectionFields, alteredSectionFields, false, {}, {});
        const alteredFormFields = [
            {columnCode: "SectionA", section:sectionFields},
            {columnCode: "SectionB", section:sectionFields},
            {columnCode: "SectionC", section:sectionFields},
            {columnCode: "SectionD", section:sectionFields}
        ]
        EmployeeListService.getAlteredConfigDetails(formConfig, alteredFormFields, false, {}, {});
        const alterFieldConfigs = [
            {fieldColumnCode: 1 , sectionColumnCode:0, fieldConfig: {columnCode : "openMarketValueAtGrantDate", readOnly: true} },
            {fieldColumnCode: 1 , sectionColumnCode:1, fieldConfig: {columnCode : "openMarketValueAtGrantDate", readOnly: true} },
            {fieldColumnCode: 1 , sectionColumnCode:2, fieldConfig: {columnCode : "openMarketValueAtGrantDate", readOnly: true} },
            {fieldColumnCode: 1 , sectionColumnCode:0, fieldConfig: {columnCode : "planGrantDate",  validation:["noFutureDate"], tooltipText:"Date of Grant cannot be a future Date"}},
            {fieldColumnCode: 1 , sectionColumnCode:1, fieldConfig: {columnCode : "planGrantDate",  validation:["noFutureDate"], tooltipText:"Date of Grant cannot be a future Date"}},
            {fieldColumnCode: 1 , sectionColumnCode:2, fieldConfig: {columnCode : "planGrantDate",  validation:["noFutureDate"], tooltipText: "Date of Grant cannot be a future Date"}},
            {fieldColumnCode: 2 , sectionColumnCode:0, fieldConfig: {columnCode : "planGrantDate", specificDate: "31/12/2013", validation: ["notAfterSpecificDate"], tooltipText:"Date of Grant must not be later than 31 Dec 2013"}},
            {fieldColumnCode: 2 , sectionColumnCode:1, fieldConfig: {columnCode : "planGrantDate", specificDate: "31/12/2013", validation: ["notAfterSpecificDate"], tooltipText:"Date of Grant must not be later than 31 Dec 2013"}},
            {fieldColumnCode: 2 , sectionColumnCode:2, fieldConfig: {columnCode : "planGrantDate", specificDate: "31/12/2013", validation: ["notAfterSpecificDate"], tooltipText:"Date of Grant must not be later than 31 Dec 2013"}},
            {fieldColumnCode: 3 , sectionColumnCode:0, fieldConfig: {columnCode : "planGrantDate", specificDate: "31/12/2013", validation: ["notAfterSpecificDate"], tooltipText:"Date of Grant must not be later than 31 Dec 2013"}},
            {fieldColumnCode: 3 , sectionColumnCode:1, fieldConfig: {columnCode : "planGrantDate", specificDate: "31/12/2013", validation: ["notAfterSpecificDate"], tooltipText:"Date of Grant must not be later than 31 Dec 2013"}},
            {fieldColumnCode: 3 , sectionColumnCode:2, fieldConfig: {columnCode : "planGrantDate", specificDate: "31/12/2013", validation: ["notAfterSpecificDate"], tooltipText:"Date of Grant must not be later than 31 Dec 2013"}},
            {fieldColumnCode: 4 , sectionColumnCode:0, fieldConfig: {columnCode : "planGrantDate", fromDate:"16/02/2008", toDate:"13/02/2013", validation: ["betweenDate"], tooltipText:"Date of Grant must be between 16th Feb 2008 to 13th Feb 2013"}},
            {fieldColumnCode: 4 , sectionColumnCode:1, fieldConfig: {columnCode : "planGrantDate", fromDate:"16/02/2008", toDate:"13/02/2013", validation: ["betweenDate"], tooltipText:"Date of Grant must be between 16th Feb 2008 to 13th Feb 2013"}},
            {fieldColumnCode: 4 , sectionColumnCode:2, fieldConfig: {columnCode : "planGrantDate", fromDate:"16/02/2008", toDate:"13/02/2013", validation: ["betweenDate"], tooltipText:"Date of Grant must be between 16th Feb 2008 to 13th Feb 2013"}}
        ]
        const config = EmployeeListService.getAlteredFormConfig(deepClone(formConfig), alterFieldConfigs);
        const alteredFields = [{columnCode : "authorizePerson", options: users }]
        const config1 = EmployeeListService.getAlteredSectionConfigDetails(config, alteredFields, "fields", 0)
        setAppendix8BFromConfig(config1);
    }

    const onSave = () => {
        if(!isValidSubmission()) {
            return;
        }
        try{
            showLoader("Updating form... Please wait");
            const parameter = {
                employeeFullName : formValues["employeeFullName"]
            };
            prepareFormData(parameter);
            IRASService.saveAppendix8BDetails(parameter).then((response) => {
                if(response) {
                    showToast("Form updated successfully", TOAST_TYPE.SUCCESS);
                    if (props.onClose()) props.onClose();
                }
                removeLoader();
            });
        }catch(err) {
            removeLoader();
            showToast("Something went wrong", TOAST_TYPE.ERROR);
        }
        
    }

    const isValidSubmission = () => {
        const config = deepClone(appendix8BFromConfig);
        const totalAlteredConfig=[];
        const sectionToExpand = [];
        const alteredConfig = [] ;
        const alteredSectionConfig = [];
        let isValid = true;
        for(let l = 0; l < config.length; l++) {            
            let element = config[l];
            if(element.isSection) {
                for(let s = 0; s < element.section.length;s++) {
                    let subSection = element.section[s];
                    for(let sb = 0; sb < subSection.fields.length; sb++) {
                        let f = subSection.fields[sb];
                        const {isValid, errMsg} = checkFieldValidation(f, getFormValue(f,subSection,element, true ));
                        if(!isValid) {
                            alteredSectionConfig.push({fieldColumnCode: l , sectionColumnCode:s, fieldConfig: {columnCode : f.columnCode, hasError: !isValid, errMsg : errMsg}}); 
                            totalAlteredConfig.push({columnCode : f.columnCode});
                            sectionToExpand.push({sectionCode: element.columnCode, subSectionCode:subSection.columnCode, columnCode: f.columnCode});
                        }
                    }
                }
            } else {
                element.fields.forEach((f, index) => {
                    const {isValid, errMsg} = checkFieldValidation(f, formValues[f.columnCode]);
                    if(!isValid) {
                        alteredConfig.push({columnCode : f.columnCode, hasError: !isValid, errMsg: errMsg});
                        totalAlteredConfig.push({columnCode : f.columnCode});
                    }
                });
            }       
        }   
        
        if(!Utility.isEmpty(totalAlteredConfig.length)) {
            EmployeeListService.getAlteredFormConfig(config, alteredSectionConfig);
            EmployeeListService.getAlteredSectionConfigDetails(config, alteredConfig, "fields", 0); 
           if(!Utility.isEmpty(sectionToExpand.length)) expandInvalidSection(sectionToExpand[0]);
           scrollToError(alteredConfig[0]?.columnCode);
           isValid = false;
        }
        setAppendix8BFromConfig(config);
        return isValid;
    }

    const prepareFormData = (parameter) => {
        const defaultValues = deepClone(formDetails);
        for(const k in defaultValues) {
            switch(k) {
                case "authorizePerson":
                    parameter[k] = formValues["authorizePerson"];
                    break;
                case "sections" :
                    parameter[k] = prepareFormSectionValues();
                    break;
                default:
                    parameter[k] = defaultValues[k];
                
            }
        }

    }

    const prepareFormSectionValues = () => {
        const sections = [];
        for(let f = 0; f < appendix8BFromConfig.length; f++) {
            const field = appendix8BFromConfig[f];
            if(field.isSection) {
                for(let s = 0; s < field.section.length; s++) {
                    const subSection = field.section[s];
                    const sbSectionValue = formValues[field.columnCode][subSection.columnCode];
                    if (!Utility.isEmpty(sbSectionValue)) {
                        let group = {};
                        for (const k in sbSectionValue) {
                            switch (k) {
                                case "dateOfExpiryOfExercise":
                                case "exerciseDate":
                                case "planGrantDate":
                                    group[k] = getDateValueForSave(sbSectionValue[k]);
                                    break;
                                case "planGrantedType":
                                case "typeOfExercise":
                                    group[k] = EmployeeListService.getSelectedIdFromObject(sbSectionValue[k],"id");
                                    break;
                                default:
                                    group[k] = sbSectionValue[k];
                            }
                        }
                        group["sectionType"] = field.columnCode;
                        group["sectionIndex"] = s;
                        sections.push(group);
                    }
                }
            }
        }
        return sections;
    }

    const getDateValueForSave = (value) => {
        if(!Utility.isEmpty(value)) {
            let dateValue = value;
            const formattedValue = moment(dateValue).format("YYYY-MM-DD");
            return formattedValue;
        } else {
            return value;
        }
    }

    const expandInvalidSection = (c) => {
        if(c?.sectionCode) {
            const expansionState = deepClone(expandedState);
            expansionState[c.sectionCode].isExpanded = true;
            expansionState[c.sectionCode][c.subSectionCode].isExpanded = true;
            setTimeout(() => {
                scrollToError(`${c.columnCode}${c.sectionCode}${c.subSectionCode}`);
            },100);
            setFormExpandedState(expansionState);
        }
    }

    const onChange = (value,f, fIndex, sbIndex, sIndex, sb, s, isNested) => {
        const alteredConfig = [];
        const authorizedConfig = [];
        const config = deepClone(appendix8BFromConfig);
        let {isValid, errMsg} = checkFieldValidation(f, value);
        if(isValid) {
            value = removeFirstDecimalFromInput(value);
            setFormValue(value, f, sb, s, isNested);
            switch(f.columnCode) {
                case "authorizePerson":
                    authorizedConfig.push({columnCode : "authorizePerson",  hasError: !isValid, errMsg : errMsg })
                    EmployeeListService.getAlteredSectionConfigDetails(config, authorizedConfig, "fields", 0)
                    break;
                default:
                    alteredConfig.push({fieldColumnCode: sIndex , sectionColumnCode:sbIndex, fieldConfig: {columnCode : f.columnCode, hasError: !isValid, errMsg : errMsg}});
                    EmployeeListService.getAlteredFormConfig(config, alteredConfig);            }
        } else {
            setFormValue(value, f, sb, s, isNested);
            switch(f.columnCode) {
                case "authorizePerson":
                    authorizedConfig.push({columnCode : "authorizePerson",  hasError: !isValid, errMsg : errMsg });
                    EmployeeListService.getAlteredSectionConfigDetails(config, authorizedConfig, "fields", 0)
                    break;
                default:
                    alteredConfig.push({fieldColumnCode: sIndex , sectionColumnCode:sbIndex, fieldConfig: {columnCode : f.columnCode, hasError: !isValid, errMsg : errMsg}});
                    EmployeeListService.getAlteredFormConfig(config, alteredConfig);
            }
        }
        setAppendix8BFromConfig(config);
    }

    const checkFieldValidation = (field, value) => {
        let isValid = true;
        let errMsg = CONSTANTS.EMPTY_STRING;
        field?.validation?.forEach((v) => {
            switch(v) {
                case "required":
                    if(Utility.isEmpty(value)) {
                        isValid = false;
                        errMsg = `Enter a valid ${field.name}`
                    }
                    break;
                case "noDecimal":
                    if(typeof(value) === "string" && value.includes(".")) {
                        isValid = false;
                        errMsg = "Decimal value is not allowed"
                    } else if(typeof(value) === "number" && (value - Math.floor(value)) !== 0) {
                        isValid = false;
                        errMsg = "Decimal value is not allowed"
                    }
                    break;
                case "minLength":
                    if(value?.length < field.minLength) {
                        isValid = false;
                        errMsg = `Charaters should be minimum of ${field.minLength} letters`;
                    }
                    break;
                case "maxLength":
                    if(value?.length > field.maxLength) {
                        isValid = false;
                        errMsg = `Length should not exceed ${field.maxLength} digits`;
                    }
                    break;
                case "currentYear":
                    if(!Utility.isEmpty(value)) {
                        const currentYear = moment().get("year");
                        const enteredYear = moment(value).get("year");
                        if(currentYear != enteredYear) {
                            isValid = false;
                            errMsg = `The year must be ${currentYear} only`;
                        }
                    }
                    break;
                case "noFutureDate":
                    if(!Utility.isEmpty(value)) {
                        const todaysDate = moment();
                        const enteredDate = moment(value);
                        if(enteredDate.isAfter(todaysDate)) {
                            isValid = false;
                            errMsg = `${field.name} cannot be a future date`;
                        }
                    }
                    break;
                case "betweenDate":
                    if(!Utility.isEmpty(value)) {
                        const date1 = moment(field.fromDate, "DD/MM/YYYY");
                        const date2 = moment(field.toDate, "DD/MM/YYYY");
                        if(!moment(value).isBetween(date1,date2, undefined, '[]')) {
                            isValid = false;
                            errMsg = `${field.name} should be between ${date1.format("MMMM Do YYYY")} to ${date2.format("MMMM Do YYYY")}`;
                        }
                    }
                    break;
                case "notAfterSpecificDate":
                    if(!Utility.isEmpty(value)) {
                        const specificDate = moment(field.specificDate,"DD/MM/YYYY");
                        const enteredDate = moment(value);
                        if(enteredDate.isAfter(specificDate)) {
                            isValid = false;
                            errMsg = `${field.name} must not be later than ${specificDate.format("MMMM Do YYYY")}`;
                        }
                    }
                    break;
                case "basisYear":
                    if(!Utility.isEmpty(value)) {
                        const basisYear = formDetails?.year;
                        const enteredYear = moment(value).get("year");
                        if(basisYear != enteredYear) {
                            isValid = false;
                            errMsg = `The year must be Income Year which is ${basisYear} only`;
                        }
                    }
                    break;

            }
        });
        return {isValid:isValid, errMsg: errMsg}
    }

    const getFormValue = (f, sb, s, isNested) => {
        if(isNested) {
            if(!Utility.isEmpty(formValues[s.columnCode]) && !Utility.isEmpty(formValues[s.columnCode][sb.columnCode]) && !Utility.isEmpty(formValues[s.columnCode][sb.columnCode][f.columnCode])) {
                return formValues[s.columnCode][sb.columnCode][f.columnCode];
            } else {
                return CONSTANTS.EMPTY_STRING;
            }
        } else {
            return formValues[f.columnCode];
        }
        
    }

    const setFormValue = (v,f, sb, s, isNested) => {
        if(isNested) {
            if(!Utility.isEmpty(s.columnCode) && !Utility.isEmpty(sb.columnCode) && !Utility.isEmpty(f.columnCode)) {
                return formValues[s.columnCode][sb.columnCode][f.columnCode] = v;
            }
        } else {
            return formValues[f.columnCode] = v;
        }
        
    }

    const getFieldRequired = (field) => {
        const validator = field.validation;
        let isRequired = false;
        if(validator && validator.some(x => x === "required")) isRequired = true;
        return isRequired;

    }

    const onExpandCollapse = (state, isSection, s, isSubSection, sb) => {
        const expansionState = deepClone(expandedState);
        if(isSection) {
            if(isSubSection) {
                expansionState[s.columnCode][sb.columnCode].isExpanded = state;
            } else {
                expansionState[s.columnCode].isExpanded = state;
            }
        }
        setFormExpandedState(expansionState);
    }

    const getTooltip = (obj) => {
        return (
            <div class="custom-tooltip position-relative width-auto ">
                <DKIcon
                    src={DKIcons.ic_info}
                    className="ml-s ic-s ml-r  cursor-hand "
                    style={{ opacity: 0.4 }}
                />
                <span class={`custom-tooltiptext dk-input-holder border-radius-m 
                                    shadow-m bg-white text-dark-gray border-m 
                                    position-fixed p-m border-box z-index-6 ${obj.tooltipClass}`}>
                    <DKLabel text={obj.tooltipText}/>
                </span>
            </div>
        )
    }

    const getFields = (fields, sbIndex, sectionIndex, sb, s, isNested) => {
        return(
            fields.map((field, fieldIndex) => {
                switch(field.columnCode) {
                    case "taxRefNo":
                    return (
                        <>
                            <div className={`web-width-50 ${field.columnCode}${s.columnCode}${sb.columnCode}`} id={field.columnCode}>
                                <div className="p-h-l mb-l" style={{ width: "90%" }}>
                                    <MaskInput
                                        setRef={(ref) => ERF.ADD_EMPLOYEE[field.columnCode] = ref}
                                        showMask={mask}
                                        title={field.name}
                                        direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                        value={getFormValue(field, sb, s, isNested)}
                                        errorMessage={field.errMsg}
                                        readOnly={field.readOnly}
                                        required={getFieldRequired(field)}
                                        tooltip={{
                                            content: field.tooltipText,
                                            className: "warning-tooltip-prop",
                                        }}
                                        onChange={(value) => {
                                            onChange(value,field, fieldIndex, sbIndex, sectionIndex,sb, s, isNested)
                                        }}
                                        canValidate={field.hasError}
                                        invalid={field.hasError}
                                        showMaskUnmaskInline={field.showMaskUnmaskInline}
                                    />
                                </div>
                            </div>

                        </>
                    );
                    default:
                        return (
                            <>
                                {
                                    (field.type === INPUT_TYPE.TEXT || field.type === INPUT_TYPE.NUMBER) && (
                                        <div className={`web-width-50 ${field.columnCode}${s.columnCode}${sb.columnCode}`} id={field.columnCode}>
                                            <div className="p-h-l mb-l" style={{ width: "90%" }}>
                                                <div className="row ">
                                                    <DKLabel className="" text={`${field.name} ${getFieldRequired(field) ? "*" : ""}`} />
                                                    {field.tooltipText && field.tooltipText != "" && (
                                                        getTooltip(field)
                                                    )}
                                                </div>
                                                <DKInput                                                    
                                                    title={""}
                                                    placeholder={field.name}
                                                    value={getFormValue(field, sb, s, isNested)}
                                                    type={field.type}
                                                    hasError={field.hasError}
                                                    labelClassName=" text-align-left "
                                                    onChange={(value) => {
                                                        onChange(value,field, fieldIndex, sbIndex, sectionIndex,sb, s, isNested)
                                                    }}
                                                    direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                                    required={getFieldRequired(field)}
                                                    readOnly={field.readOnly}
                                                    tooltip={{
                                                        content: field.tooltipText,
                                                        className: "warning-tooltip-prop",
                                                    }}
                                                    canValidate={field.hasError}
                                                    validator={(value) => {
                                                        return !field.hasError;
                                                    }}
                                                    errorMessage={field.errMsg}
                                                />
                                            </div>
                                        </div>
                                    )
                                }
                                {
                                    (field.type === INPUT_TYPE.DROPDOWN || field.type === INPUT_TYPE.MULTI_SELECT) && (
                                        <div className={`web-width-50 ${field.columnCode}${s.columnCode}${sb.columnCode}`} id={field.columnCode}>
                                            <div className="p-h-l mb-l" style={{ width: "90%" }}>
                                                <div className=" row ">
                                                    <DKLabel className="" text={`${field.name} ${getFieldRequired(field) ? "*" : ""}`} />
                                                    {field.tooltipText && field.tooltipText != "" && (
                                                        getTooltip(field)
                                                    )}
                                                </div>
                                                <DKInput
                                                    title={""}
                                                    placeholder={field.name}
                                                    value={getFormValue(field, sb, s, isNested)}
                                                    formatter={(field) => {
                                                        /** How to render a selected option in case of object **/
                                                        return field.name;
                                                    }}
                                                    type={field.type}
                                                    hasError={field.hasError}
                                                    labelClassName=" text-align-left "
                                                    onChange={(value) => {
                                                        onChange(value,field, fieldIndex, sbIndex, sectionIndex,sb, s, isNested)
                                                    }}
                                                    direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                                    required={getFieldRequired(field)}
                                                    readOnly={field.readOnly}
                                                    tooltip={{
                                                        content: field.tooltipText,
                                                        className: "warning-tooltip-prop",
                                                    }}
                                                    dropdownConfig={{
                                                        className: "",
                                                        style: {},
                                                        allowSearch:
                                                            field.options && field.options.length > 6
                                                                ? true
                                                                : false,
                                                        searchableKey: "name",
                                                        data: field.options,
                                                        renderer: (index, obj) => {
                                                            /** How to render value in Dropdown in case of object **/
                                                            return <DKLabel text={`${obj.name}`} />;
                                                        },
                                                        multiSelect: false,
                                                        
                                                    }}
                                                    canValidate={field.hasError}
                                                    validator={(value) => {
                                                        return !field.hasError;
                                                    }}
                                                    errorMessage={field.errMsg}
                                                />
                                            </div>

                                        </div>
                                    )
                                }
                                {
                                    (field.type === INPUT_TYPE.DATE) && (
                                        <div className={`web-width-50 ${field.columnCode}${s.columnCode}${sb.columnCode}`} id={field.columnCode}>
                                            <div className="p-h-l mb-l" style={{ width: "90%" }}>
                                                <div className=" row ">
                                                    <DKLabel className="" text={`${field.name} ${getFieldRequired(field) ? "*" : ""}`} />
                                                    {field.tooltipText && field.tooltipText != "" && (
                                                        getTooltip(field)
                                                    )}
                                                </div>
                                                <DKInput                                                    
                                                    title={""}
                                                    placeholder={field.name}
                                                    value={getFormValue(field, sb, s, isNested)}
                                                    type={field.type}
                                                    hasError={field.hasError}
                                                    labelClassName=" text-align-left "
                                                    onChange={(value) => {
                                                        onChange(value,field, fieldIndex, sbIndex, sectionIndex,sb, s, isNested)
                                                    }}
                                                    direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                                    required={getFieldRequired(field)}
                                                    readOnly={field.readOnly}
                                                    tooltip={{
                                                        content: field.tooltipText,
                                                        className: "warning-tooltip-prop",
                                                    }}
                                                    /* Commenting can be used further
                                                    canValidate={field.hasError}
                                                    validator={(value) => {
                                                        return !field.hasError;
                                                    }}
                                                    errorMessage={field.errMsg}
                                                    */
                                                />
                                                {field.hasError && (
                                                    <DKLabel
                                                        // className="pl-s fs-s unselectable text-red"
                                                        text={field.errMsg}
                                                        className="text-red ml-xs mt-xs"
                                                        style={{ fontSize: 11 }}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    )
                                }
                            </>
                        )
                }
            })
        )
    }

    const getSubSections = (s, sIndex) => {
        return(
            s.section.map((sb, sbIndex) => {
                return(
                    <>
                        <div className="m-v-l m-h-l bg-white border-radius-s card-shadow-form">
                            <DKExpandableWrapper
                                id={sb.columnCode}
                                title={sb.title}
                                className="collapsable mb-s"
                                expanded={expandedState[s.columnCode]?.[sb.columnCode].isExpanded ? true: false}
                                headerStyle={{ padding: "20px" }}
                                onClick={(expanded) => {
                                    onExpandCollapse(expanded, true, s, true, sb);
                                }}
                            >
                                <DKLine className="bg-line-2" />
                                <div
                            style={{
                                display: "flex",
                                flexWrap: "wrap",
                            }}
                            className=" parent-width mb-s pb-m pt-s"
                        >
                            {getFields(sb.fields, sbIndex, sIndex,sb, s, true)}
                        </div>
                            </DKExpandableWrapper>
                        </div>
                    </>
                )
            })
        )
    }

    const getFieldSections = (f, fIndex) => {
        return (
            <>
                <div className="mt-xl parent-width bg-white border-radius-s card-shadow-form">
                    <DKExpandableWrapper
                        id={f.columnCode}
                        title={`<div class="row">${f.title}   <div class="fs-r text-gray fw-l my-auto">${f.description}</div></div>`}
                        className="collapsable"
                        expanded={expandedState[f.columnCode]?.isExpanded ? true: false}
                        headerStyle={{ padding: "20px" }}
                        onClick={(expanded) => {
                            onExpandCollapse(expanded, true, f, false, CONSTANTS.EMPTY_STRING);
                        }}
                    >
                        <DKLine className="bg-line-2" />
                        <div className="pb-xs">
                            {getSubSections(f, fIndex)}
                        </div>

                    </DKExpandableWrapper>
                </div>
            </>
        )
    }

    const getSections = () => {
        return(
            appendix8BFromConfig.map((field, fieldIndex) => {
                return(
                    <>
                        <div>
                            {!field.isSection && (
                                <div
                                    style={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                    }}
                                    className=" parent-width mb-s pb-m pt-s"
                                >
                                    {getFields(field.fields, 0, 0,{}, {}, false)}
                                </div>
                            )}
                            {field.isSection && (
                                getFieldSections(field, fieldIndex)
                            )}
                        </div>
                    </>
                )
            })
        )

    }

    const getHeader = () => {
        return (
            <div className="row justify-content-between p-h-m">
                <div className="row">
                    <DKLabel
                        text={"Edit Appendix 8B Form"}
                        className="fw-b fs-m"
                    />
                    {isLoading && <DKSpinner className="pl-s" />}
                </div>
                <div className="row width-auto">
                    <DKButton
                        title="Cancel"
                        className="bg-gray1 border-m"
                        onClick={() => {
                            props.onClose(false);
                        }}
                    />
                    <DKButton
                        title="Save"
                        className="bg-button text-white ml-r"
                        onClick={() => {
                            onSave();
                        }}
                    />
                </div>
            </div>
        );
    };

    return(
        <>
            <div className=" transparent-background-light">
                <div className="p-h-r pt-r pb-xl popup-window" style={{maxWidth:"60%", width:"100%"}}>
                    <div className="popup-wrapper parent-width parent-height">
                    {getHeader()}
                    <div className="p-m">{getSections()}</div>
                    </div>
                </div>
            </div>
        </>
    );

}

export default Appendix8BForm;